import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

type DisplayType = {
  $displaytype?: 'row' | 'column';
  $isselected: 'true' | 'false';
};

const StyledButton = styled.div<DisplayType>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 9px;
  padding-top: 5px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  text-wrap: nowrap;
  background: ${({ theme, $isselected }) =>
    $isselected === 'true' ? theme.components.tipBox.backgroundColor.selected : theme.components.tipBox.backgroundColor.unselected};
  text-align: center;
  border: solid;
  border-radius: ${({ theme }) => theme.components.tipBox.border.radius}px;
  border-width: 1px;
  border-color: ${({ theme, $isselected }) =>
    $isselected === 'true' ? theme.components.tipBox.border.selectedBorderColor : theme.components.tipBox.border.color};
  color: ${({ theme, $isselected }) =>
    $isselected === 'true' ? theme.components.tipBox.text.color.selected : theme.components.tipBox.text.color.unselected} !important;

  ${({ $displaytype }) =>
    $displaytype === 'column' &&
    `
    flex: 1;
    padding-top: 6px;
    padding-bottom: 6px;
  `}
`;

interface TipBoxProps {
  tip?: number;
  isSelected: boolean;
  onSelected(tip?: number): any;
  displayType?: 'row' | 'column';
}

const TipBox: React.FC<TipBoxProps> = ({ tip, isSelected = false, onSelected, displayType }) => {
  const { t } = useTranslation();

  return (
    <StyledButton $displaytype={displayType} $isselected={`${isSelected}`} onClick={() => onSelected(tip)}>
      {tip ? t('common.localAmount', { amount: tip }) : t('common.no')}
    </StyledButton>
  );
};

export default TipBox;
